import http from '../../utils/fetch';
export default {

    baseurl:'/api/swyl/v1/xiangmu/proProductInfo',
    getProductInfoByProjectId(projectId){
        return http({
            url: this.baseurl+'/getProductInfoByProjectId',
            method: 'post',
            params: {"projectId":projectId}
        });
    },
    page(query){
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: query
        });
    },
    updateXuniTozhanshi(query){
        return http({
            url: this.baseurl+'/updateById',
            method: 'post',
            params: query
        });
    }



}
